import React from 'react'

const Startup = () => {
    return (
        <div className='container'>
            <div class="x-container max width">

<header class="entry-header">
    <h1 class="entry-title">Startup Roadmap: What Is It and Why Do You Need One?</h1>
</header>
<div class="entry-featured">
    <div class="entry-thumb"><img width="568" height="426"
            src="https://www.jibility.com/wp-content/uploads/2019/09/startup-roadmap-blog.png"
            class="attachment-entry-fullwidth size-entry-fullwidth wp-post-image" alt="" loading="lazy"
            srcset="https://www.jibility.com/wp-content/uploads/2019/09/startup-roadmap-blog.png 568w, https://www.jibility.com/wp-content/uploads/2019/09/startup-roadmap-blog-300x225.png 300w, https://www.jibility.com/wp-content/uploads/2019/09/startup-roadmap-blog-100x75.png 100w"
            sizes="(max-width: 568px) 100vw, 568px" wpfc-lazyload-disable="true"/></div>
</div>


<div class="entry-content content">


    <div id="cs-content" class="cs-content">
        <div class="e4568-1 x-section" style={{paddingBottom:'20px'}}>

            <div class="e4568-2 x-container max width">

                <div class="e4568-3 x-column x-sm x-1-1">
                    <div class="x-text cs-ta-center" style={{fontSize:'18px'}}>
                        <p><i>By Jibility Co-Founder Chris Benthien</i></p>
                    </div>
                    <hr class="x-gap" style={{margin: '40px 0 0 0'}}/>
                </div>
            </div>

            <div class="e4568-6 x-container max width">

                <div class="e4568-7 x-column x-sm x-1-2">
                    <div class="x-text" style={{fontSize:'18px'}}>
                        <p>So, you have decided to take the plunge and found a startup. You’ve clarified your
                            mission and vision, completed your business model canvas, created a value proposition,
                            created a fantastic business name, fleshed out the product MVP, and produced a business
                            plan complete with financial projections.</p>
                        <p>Now what?</p>
                    </div>
                </div>

              
            </div>

            <div class="e4568-11 x-container max width">

                <div class="e4568-12 x-column x-sm x-1-1">
                    <div class="x-text cs-ta-left" style={{fontSize: '18px'}}>
                        <p>Many people jump straight into action and more often than not spend the bulk of their
                            time working on their product, often neglecting other key aspects of their startup
                            business.</p>
                        <p>Enter the <a href="/what-is-a-strategy-roadmap/">strategy roadmap</a>: a key planning
                            tool that helps keep you focused on what matters most.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="e4568-14 x-section" style={{paddingTop:'20px' , paddingBottom:'40px'}}>

            <div class="e4568-15 x-container max width">

                <div class="e4568-16 x-column x-sm x-1-1">
                    <h2 class="h-custom-headline cs-ta-left h3"><span>What is a Startup Strategy Roadmap? </span>
                    </h2>
                    <hr class="x-gap" style={{margin: '30px 0 0 0'}}/>
                </div>
            </div>

            <div class="e4568-19 x-container max width">

                <div class="e4568-20 x-column x-sm x-1-1">
                    <div class="x-text cs-ta-left" style={{fontSize: '18px'}}>
                        <p>What to do and where to focus? Two big questions that a strategy roadmap helps you
                            answer.</p>
                        <p>Your startup strategy roadmap will help you systematically determine:</p>
                    </div>
                    <div class="x-text cs-ta-left" style={{fontSize: '18px', padding:'5%'}}>
                        <ol class="list">
                            <li>What capabilities you need to get your startup off the ground and growing.</li>
                            <li>What actions and initiatives you should take (and in what priority) to build out
                                those capabilities.</li>
                        </ol>
                    </div>
                    <div class="x-text cs-ta-left" style={{fontSize: '18px'}}>
                        <p>Strategy roadmaps are living, breathing organisms. Unlike your mission and vision, your
                            roadmap is under constant iteration and is your key tool for helping you prioritize what
                            to do next in your business.</p>
                        <p>It helps you look at the business holistically by encompassing processes (e.g. workflows
                            and methods), physical/technical components (e.g. facilities and technology) and people
                            (e.g. culture and skills).</p>
                        <p>Many startups make the mistake of focusing heavily on the physical aspects, such as the
                            technology that underpins their product. But often the success of a business (or the
                            major risks) lie in the people and process realms.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="e4568-24 x-section" style={{paddingBottom:'20px'}}>

            <div class="e4568-25 x-container max width">

                <div class="e4568-26 x-column x-sm x-1-1">
                    <h2 class="h-custom-headline cs-ta-left h3"><span>Why a Strategy Roadmap is Critical to Your
                            Investors </span></h2>
                    <hr class="x-gap" style={{margin: '30px 0 0 0'}}/>
                </div>
            </div>

            <div class="e4568-29 x-container max width">

                <div class="e4568-30 x-column x-sm x-1-1">
                    <div class="x-text cs-ta-left" style={{fontSize:'18px'}}>
                        <p>Having developed a great pitch deck, backed by a solid business plan showing financial
                            projections for growth, you are now seeking funding to establish your startup or scale
                            your operations. </p>
                    </div>
                </div>
            </div>

            <div class="e4568-32 x-container max width">

                <div class="e4568-33 x-column x-sm x-1-2">
                    <div class="x-text cs-ta-left" style={{fontSize:'18px'}}>
                        <p>The question always asked by investors is: <i>“What do you plan to spend the invested
                                capital on?”</i></p>
                        <p>The answer is nearly always product development and sales. But what beyond this broad
                            statement will give investors confidence that you have a well thought-through plan for
                            using their capital to maximize your business objectives?</p>
                    </div>
                    <hr class="x-gap" style={{margin: '25px 0 0 0'}}/>
                </div>

                <div class="e4568-36 x-column x-sm x-1-2">

                    <div class="e4568-37 x-text">
                        <i>“VCs want you to be able to explain how you are going to use their money. It sounds
                            self-evident, but it really needs to be spelled out…
                            Will you invest in advertising? Will you hire new talent, either a top-flight executive
                            or new sales staff? Will you use the funds to acquire a small firm that provides
                            something you need so you don’t have to develop it in-house?”</i>
                        <p>
                            <br/><a href="https://www.klipfolio.com/blog/venture-capitalists" target="_blank">Allan
                                Wille, Co-Founder and Chief Innovation Officer of Klipfolio</a>
                        </p>
                    </div>
                </div>
            </div>

            <div class="e4568-38 x-container max width">

                <div class="e4568-39 x-column x-sm x-1-1">
                    <div class="x-text cs-ta-left" style={{fontSize:'18px'}}>
                        <p>The answer lies in a strategy roadmap, which demonstrates robust thinking about the
                            startup business. This type of startup roadmap identifies what capabilities need to be
                            invested in, provides the “science” behind the initiatives that you plan to undertake,
                            and ultimately helps you avoid the common pitfall of poor
                                prioritization.</p>
                        <p>The approach we outline below will help you to produce a strategy roadmap that
                            demonstrates a well-articulated plan for your startup business. This approach includes
                            outlining specific key objectives, <a href="/business-capability-definition/">business
                                capabilities</a>, and prioritized, costed and sequenced initiatives on an easily
                            digestible roadmap.</p>
                        <p>This assures your investors that you have a simple but disciplined approach to spending
                            their hard-earned capital, ensuring that it doesn’t get consumed by activities that are
                            easy or non-urgent. They will have confidence that you have an ongoing approach to
                            determining critical initiatives for funding.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="e4568-41 x-section" style={{paddingBottom:'20px'}}>

            <div class="e4568-42 x-container max width">

                <div class="e4568-43 x-column x-sm x-1-1">
                    <h2 class="h-custom-headline cs-ta-left h3"><span>Creating a Startup Strategy Roadmap the
                            Jibility Way </span></h2>
                </div>
            </div>

            <div class="e4568-45 x-container max width">

                <div class="e4568-46 x-column x-sm x-1-1">
                    <hr class="x-gap" style={{margin: '30px 0 0 0'}}/>
                    <div class="x-text" style={{fontSize:'18px'}}>
                        <p>The <a href="/six-steps-develop-strategy-roadmap/">Jibility method</a> for creating
                            strategy roadmaps consists of six simple steps. </p>
                    </div>
                </div>
            </div>

            <div class="e4568-49 x-container max width">

                

                <div class="e4568-53 x-column x-sm x-5-6">
                    <h3 class="h-custom-headline h4"><span>Challenges</span></h3>
                    <hr class="x-gap" style={{margin: '20px 0 0 0'}}/>
                    <div class="x-text" style={{fontSize:'18px'}}>
                        <p><b>Define the top challenges your startup is facing at this point in time.</b></p>
                        <p>You’ll face a different set of challenges at each stage of your startup, from formation,
                            to seed funding, all the way to Series A funding and beyond.</p>
                        <p>In the early stages, these challenges often revolve around funding, establishing your
                            first MVP of the product and finding the right founding team.</p>
                        <p>In the later stages, you could be faced with challenges related to scaling. For example,
                            establishing customer support processes, strengthening revenue collection systems and
                            ramping up production volumes.</p>
                        <p>The trick is to keep it simple and focused: only identify the current top 5-6 challenges.
                        </p>
                    </div>
                </div>
            </div>

            <div class="e4568-57 x-container max width">

              

                <div class="e4568-61 x-column x-sm x-5-6">
                    <h3 class="h-custom-headline h4"><span> Objectives </span></h3>
                    <hr class="x-gap" style={{margin: '20px 0 0 0'}}/>
                    <div class="x-text" style={{fontSize:'18px'}}>
                        <p><b>Set key objectives for this planning horizon.</b></p>
                        <p>Set your objectives based on your current challenges. Maybe it’s <i>“raise $500k in seed
                                funding”</i> in response to your current funding challenge. Perhaps it’s
                            <i>“strengthen customer support to reduce complaints by 25%”</i> if you’re experiencing
                            high levels of customer problems.</p>
                        <p>This step is about being clear what you want to achieve and what constitutes success.</p>
                    </div>
                </div>
            </div>

            <div class="e4568-65 x-container max width">

               
                <div class="e4568-69 x-column x-sm x-5-6">
                    <h3 class="h-custom-headline h4"><span>Capabilities</span></h3>
                    <hr class="x-gap" style={{margin: '20px 0 0 0'}}/>
                    <div class="x-text" style={{fontSize:'18px'}}>
                        <p><b>Identify what capabilities you need to establish or invest in to reach your
                                objectives.</b></p>
                    </div>
                </div>
            </div>

            <div class="e4568-73 x-container max width">

                <div class="e4568-74 x-column x-sm x-1-6">
                    &nbsp;</div>

                <div class="e4568-75 x-column x-sm x-1-2">
                    <div class="x-text" style={{fontSize:'18px'}}>
                        <p>This is the most critical step. It is the bridge between what you want to achieve
                            (Challenges and Objectives) and what you are doing (Actions and Initiatives). Your
                            business’s capabilities describe what your business <b>does</b>. A capability is
                            typically made up of processes, people and physical things, such as technology or
                            equipment.</p>
                        <p>In this step, identify all the business capabilities that your startup business needs to
                            operate – now and in the future – and build your capability map. Reflecting
                            on your key challenges and objectives, determine which of these capabilities need to be
                            established, enhanced or invested in. Then prioritize your investments.</p>
                    </div>
                </div>

                <div class="e4568-77 x-column x-sm x-1-3" style={{padding:'20px'}}>
                   
                    <hr class="x-hr" style={{borderTopColor: '#bdbdbd' , borderTopWidth: '2px'}}/>
                    <h3 class="h-custom-headline cs-ta-center h5"><span>  a Capability Map?</span></h3>
                    <div class="x-text cs-ta-center" style={{fontSize:'15px'}}>
                        <p>Find out more about building a capability map for your business. <a
                                href="/what-is-a-capability-map/"><i class="x-icon x-icon-angle-double-right"
                                    data-x-icon-s="" aria-hidden="true"></i></a></p>
                    </div>
                </div>
            </div>

            <div class="e4568-82 x-container max width">

                <div class="e4568-83 x-column x-sm x-1-1">
                    &nbsp;</div>
            </div>

            <div class="e4568-84 x-container max width">

                

                <div class="e4568-88 x-column x-sm x-5-6">
                    <h3 class="h-custom-headline h4"><span>Courses of Action </span></h3>
                    <hr class="x-gap" style={{margin: '20px 0 0 0'}}/>
                    <div class="x-text" style={{fontSize:'18px'}}>
                        <p><b>Next, identify the actions needed to transform your most important capabilities.</b>
                        </p>
                        <p>If you are stuck for what actions to take, then just think about what makes up a
                            capability. Typically, actions revolve around <b>people</b> (hiring new talent,
                            restructuring, training, embedding culture); <b>processes</b> (fixing broken processes,
                            strengthening processes, creating processes); <b>physical</b> (acquiring new plant or
                            equipment, implementing or upgrading systems, finding new premises, obtaining funding).
                        </p>
                        <p>At this stage it is good to identify ball park costs and benefits to help you with
                            prioritisation in the next step.</p>
                    </div>
                </div>
            </div>

            <div class="e4568-92 x-container max width">

               

                <div class="e4568-96 x-column x-sm x-5-6">
                    <h3 class="h-custom-headline h4"><span>Initiatives</span></h3>
                    <hr class="x-gap" style={{margin: '20px 0 0 0'}}/>
                    <div class="x-text" style={{fontSize:'18px'}}>
                        <p><b>Group your courses of action into logical initiatives that you can execute.</b></p>
                        <p>Don’t make the initiatives too big. You want to keep your startup moving fast so that you
                            can pivot as needed.</p>
                        <p>I like to identify a set of actions that would constitute a Minimum Viable Increment to
                            one or more business capabilities, i.e. the minimum amount of actions or things that I
                            can do to take my startup to the next level.</p>
                        <p>Rome wasn’t built in a day – nor will your startup be. It’s key at this stage to
                            prioritize initiatives that move the dial on your objectives with the least effort.</p>
                    </div>
                </div>
            </div>

          

            <div class="e4568-103 x-container max width">

                

                <div class="e4568-107 x-column x-sm x-5-6">
                    <h3 class="h-custom-headline h4"><span>Your Startup Roadmap </span></h3>
                    <hr class="x-gap" style={{margin: '20px 0 0 0'}}/>
                    <div class="x-text" style={{fontSize:'18px'}}>
                        <p><b>Prioritize and sequence your initiatives, then plot them on the roadmap.</b></p>
                        <p>With your initiatives established, it’s time to create your roadmap. Start with a simple
                            grid. On the vertical, create your themes, e.g. sales and marketing, product
                            development, funding. Across the top, map out your horizons, e.g. years, quarters,
                            stages.</p>
                        <p>Plot each of your initiatives on the grid in an executable sequence. Identify
                            dependencies between initiatives.</p>
                        <p>Be wary of frontend-loading your roadmap, i.e. trying to do everything in the first
                            horizon. Most startups bite off more than they can chew. Keep focus by doing the high
                            priority initiatives early rather than trying to do everything straight up.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="e4568-111 x-section" style={{paddingTop:'20px' , paddingBottom:'40px'}}>

            <div class="e4568-112 x-container max width">

                <div class="e4568-113 x-column x-sm x-1-1">
                    <h2 class="h-custom-headline cs-ta-left h3"><span>Keeping Your Roadmap Fresh </span></h2>
                    <hr class="x-gap" style={{margin: '30px 0 0 0'}}/>
                </div>
            </div>

            <div class="e4568-116 x-container max width">

                <div class="e4568-117 x-column x-sm x-1-1">
                    <div class="x-text cs-ta-left" style={{fontSize: '18px'}}>
                        <p>And there you have it – six simple steps for creating a strategy roadmap for your
                            startup.</p>
                        <p> But you don’t have to
                                slavishly follow the steps sequentially. When I create strategy roadmaps, I
                            often jump all over the place as ideas come to me. I set some challenges and objectives.
                            Then go to my roadmap and establish some initiatives and actions. Then back validate
                            those initiatives against my capability map to gauge priority.</p>
                        <p>I constantly work on my strategy roadmaps and keep them alive. New challenges arise,
                            initiatives get completed, new capabilities are required. Startup businesses constantly
                            move and evolve and so should your strategy roadmap.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="e4568-119 x-section" style={{paddingBottom:'40px' , paddingTop:'20px'}}>

            <div class="e4568-120 x-container max width">

                <div class="e4568-121 x-column x-sm x-1-1">
                    <hr class="x-hr" style={{borderTopColor: '#bdbdbd' , borderTopWidth: '2px'}}/>
                    <hr class="x-gap" style={{margin: '40px 0 0 0'}}/>
                </div>
            </div>

            <div class="e4568-124 x-container max width">

               

                <div class="e4568-127 x-column x-sm x-2-3">
                    <h2 class="h-custom-headline cs-ta-left h3"><span>A Useful Free Tool…</span></h2>
                    <hr class="x-gap" style={{margin: '40px 0 0 0'}}/>
                    <div class="x-text cs-ta-left" style={{fontSize: '18px'}}>
                        <p>Our free app, Jibility, takes you through the above six steps. Get started for free to
                            access more examples, more expert content, and discover how quick and easy it can be to
                            create a strategic roadmap.</p>
                            
                    </div>
                    </div>
            </div>
        </div>
    </div>


</div>

</div>
        </div>
    )
}

export default Startup
